//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';
// import { List } from 'vant';
import List from 'components/list/index';
import { goodsItem, videoItem, articleItem, yList } from 'components/app';

export default {
  name: 'articleList',
  props: ['params'],
  metaInfo: {
    title: '文章列表'
  },
  created: async function () {
    // let res = await this.getList()
    // console.log('------res',this, window.__wxjs_environment === 'miniprogram')
  },
  data() {
    return {
      enterprise: this.params.enterpise || this.params.enterprise || G.member.enterprise,
      articleList: {
        code: undefined,
        data: {},
        msg: undefined
      },
      isLoading: false,
      // loading: false,
      // finished: false,
      list: {
        page: 1,
        items: []
      }
    };
  },
  computed: {},
  filters: {},
  components: {
    'ylp-list': List,
    articleItem,
    yList
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/articleList/page.vue